import React from "react";

// Default data
const defaultUnionData = [
  "Total Permanent Employees",
  "Total Permanent Workers",
].flatMap((group) =>
  ["Male", "Female"].map((gender) => ({
    group,
    gender,
    current: { total: "", union: "", percent: "" },
    previous: { total: "", union: "", percent: "" },
  }))
);

const UnionAssociationTable = ({ uniondata, setUnionData }) => {
  const handleChange = (group, gender, period, field, value) => {
    const index = uniondata.findIndex(
      (r) => r.group === group && r.gender === gender
    );
    if (index === -1) return;

    const updated = [...uniondata];
    updated[index][period][field] = value;
    setUnionData(updated);
  };

  const groups = ["Total Permanent Employees", "Total Permanent Workers"];

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan="2" style={headerStyle}>
              Gender
            </th>
            <th colSpan="3" style={headerStyle}>
              FY ____
              <br />
              Current Financial Year
            </th>
            <th colSpan="3" style={headerStyle}>
              FY ____
              <br />
              Previous Financial Year
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}>
              Total employees/ workers in respective category (A)
            </th>
            <th style={headerStyle}>
              No. of employees/ workers in respective category, who are part of
              association or union (B)
            </th>
            <th style={headerStyle}>% (B/A)</th>
            <th style={headerStyle}>
              Total employees/ workers in respective category (C)
            </th>
            <th style={headerStyle}>
              No. of employees/ workers in respective category, who are part of
              association or union (D)
            </th>
            <th style={headerStyle}>% (C/D)</th>
          </tr>
        </thead>
        <tbody>
          {groups.map((group) => (
            <React.Fragment key={group}>
              <tr>
                <td
                  colSpan="7"
                  style={{ ...groupHeaderStyle, textAlign: "center" }}
                >
                  {group}
                </td>
              </tr>
              {["Male", "Female"].map((gender) => {
                const row = uniondata.find(
                  (r) => r.group === group && r.gender === gender
                );
                if (!row) return null;

                return (
                  <tr key={`${group}-${gender}`}>
                    <td style={{ ...cellStyle, fontWeight: "bold" }}>
                      {gender}
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        placeholder="Details"
                        value={row.current.total}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "current",
                            "total",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        placeholder="Details"
                        value={row.current.union}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "current",
                            "union",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        placeholder="Details"
                        value={row.current.percent}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "current",
                            "percent",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        placeholder="Details"
                        value={row.previous.total}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "previous",
                            "total",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        placeholder="Details"
                        value={row.previous.union}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "previous",
                            "union",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        placeholder="Details"
                        value={row.previous.percent}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "previous",
                            "percent",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                      />
                    </td>
                  </tr>
                );
              })}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  width: "14%", // uniform width
  wordWrap: "break-word",
};

const groupHeaderStyle = {
  padding: "10px",
  backgroundColor: "#e7dfe2",
  fontWeight: "bold",
  border: "1px solid #000",
  textAlign: "center",
};

const cellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  width: "14%", // uniform width
};

const inputStyle = {
  width: "100%",
  padding: "8px 10px",
  fontSize: "14px",
  borderRadius: "4px",
  border: "1px solid grey",
  outline: "none",
  boxSizing: "border-box",
};

export default UnionAssociationTable;
